import React from "react";
import { Helmet } from "react-helmet-async";

const Giridih = () => {
  return (
    <>
      <Helmet>
        <title>Fly Ash Bricks & Paver Blocks Dealers in Giridih | Anil Flyash Bricks</title>
        <meta
          name="description"
          content="Anil Flyash Bricks — leading manufacturer and dealer of fly ash bricks, flyash blocks, and paver blocks in Giridih. Get durable, eco-friendly, and affordable construction materials."
        />
        <meta
          name="keywords"
          content="bricks in Giridih, flyash bricks in Giridih, fly ash blocks Giridih, bricks dealers in Giridih, flyash bricks manufacturer in Giridih, paver blocks in Giridih, paver manufacturer in Giridih, best bricks in Giridih, Anil Flyash Bricks Giridih"
        />
        <link rel="canonical" href="https://anilbricks.com/flyash-bricks-in-giridih" />
      </Helmet>

      <div className="py-16 px-6 md:px-20 bg-gray-50 text-gray-800">
        <h1 className="text-3xl font-bold mb-6 text-green-700 text-center">
          Fly Ash Bricks, Blocks & Paver Blocks in Giridih
        </h1>

        <p className="text-lg leading-relaxed mb-4">
          Welcome to <strong>Anil Flyash Bricks</strong> — Giridih’s most trusted name in
          <strong> fly ash bricks, flyash blocks, and designer paver blocks</strong>. 
          We focus on delivering <strong>eco-friendly, high-strength, and durable</strong> products 
          suitable for every kind of construction — residential, commercial, and industrial.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Our <strong>fly ash bricks</strong> are made using modern machines ensuring uniform shape,
          excellent compressive strength, and moisture resistance. In addition, our 
          <strong> paver blocks </strong> are available in multiple designs, thicknesses, and colors — 
          ideal for pathways, parking areas, and landscaping.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          If you are looking for <em>“bricks dealers in Giridih”</em>, 
          <em>“fly ash bricks near me”</em>, or 
          <em>“paver block supplier in Giridih”</em>, 
          you’ve found the right place. We deliver across <strong>Giridih, Bengabad, Jamua, Rajdhanwar, and Deori</strong> 
          with fast and reliable service.
        </p>

        <p className="text-lg leading-relaxed mb-6">
          Choose <strong>Anil Flyash Bricks</strong> for top-notch quality, affordable pricing, 
          and sustainable building materials that help protect the environment.
          We also take bulk and franchise orders — reach out today for your custom requirements.
        </p>

        <a
          href="/"
          className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-semibold shadow-md transition"
        >
          Visit Main Website
        </a>
      </div>
    </>
  );
};

export default Giridih;
